// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"b8da6a3f","636":"3a589bcc","858":"3a589bcc"}[chunkId] + ".chunk.css";
};